<template>
    <div class="main-content detail success" v-cloak>
        <div>
            <trial-over
                @close-modal="hide_trial_modal"
                v-if="trial_modal_shown"
                :shown="trial_modal_shown"
            ></trial-over>
            <div class="container">
                <div class="events-group-top">
                    <div class="events-summary">
                        <div class="events-summary-row">
                            <div class="events-summary-left">
                                Adults:
                            </div>
                            <div class="events-summary-right">
                                <span>{{ attending_adults.length }}</span
                                >/{{ adults.length }}
                            </div>
                        </div>
                        <div class="events-summary-row">
                            <div class="events-summary-left">
                                Kids:
                            </div>
                            <div class="events-summary-right">
                                <span>{{ attending_kids.length }}</span
                                >/{{ kids.length }}
                            </div>
                        </div>
                    </div>
                    <a @click="go_to_add" href="javascript:{}" :class="{ 'btn btn-primary': true }">+ Add guests</a>
                </div>

                <div class="events" style="padding-top:0 !important;">
                    <div class="events-group-row">
                        <div class="events-group">
                            <div class="events-group-header">
                                <div align="center" class="events-group-header-icon">
                                    <span>A</span>
                                </div>
                                Adults
                            </div>
                            <guest-row
                                v-if="adults && adults.length > 0"
                                v-for="(adult, inx) in adults"
                                :event_person="adult"
                                :key="inx"
                            ></guest-row>
                            <div v-if="adults && adults.length === 0" class="no-results">No adults added</div>
                        </div>
                        <div class="events-group">
                            <div class="events-group-header">
                                <div align="center" class="events-group-header-icon">
                                    <span>K</span>
                                </div>
                                Kids
                            </div>
                            <guest-row
                                v-if="kids && kids.length > 0"
                                v-for="(kid, inx) in kids"
                                :event_person="kid"
                                :key="inx"
                            ></guest-row>
                            <div v-if="kids && kids.length === 0" class="no-results">No kids added</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import guestRow from "./guest-row.vue";
import router from "@/router";
import iconDropdown from "@/components/pages/icon-dropdown.vue";
import TrialOver from "./../../trial-over-modal.vue";

export default {
    name: "guests",
    mounted() {
        this.get_current_event(this.$route.params.id);
    },
    components: {
        guestRow,
        iconDropdown,
        TrialOver
    },
    computed: {
        ...mapState("StoreEvent", ["event", "event_loaded"]),
        ...mapState("StoreEvent", ["global_errors"]),
        ...mapState(["user"]),
        ...mapGetters("StoreEvent", ["adults", "kids", "attending_kids", "attending_adults"])
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.get_logged_in_user();
            next();
        });
    },
    data() {
        return {
            trial_modal_shown: false
        };
    },
    methods: {
        ...mapActions("StoreEvent", ["get_event"]),
        ...mapActions(["get_logged_in_user"]),
        get_current_event(event_id) {
            this.get_event(event_id);
        },
        hide_trial_modal() {
            this.trial_modal_shown = false;
        },
        go_to_add() {
            if (this.user && this.user.active_plan && this.user.active_plan.id) {
                router.push({ path: "/events/" + this.event.id + "/guests/add" });
            } else {
                this.trial_modal_shown = true;
            }
        }
    }
};
</script>
<style scoped>
.events {
    height: initial;
    overflow-x: hidden;
}

.events-group {
    flex: 1;
    margin: 0 2.8rem;
    padding-bottom: 5.8rem;
}

.main-content {
    padding: 4.4rem 1.6rem 0 1.6rem;
}

.events-group-top {
    margin-top: -2.4rem;
    display: flex;
    justify-content: center;
    margin-bottom: 4.4rem;
    align-items: center;
}

@media (max-width: 82rem) {
    .main-content {
        height: 60vh;
        overflow-y: auto;
        overflow-x: hidden;
    }
}

.events-group-top .btn-primary {
    margin-left: auto;
    padding: 0.4rem 1.2rem;
}
</style>
